/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Traces_Filters_AllInputs */

const es_admin_traces_filters_all = /** @type {(inputs: Admin_Traces_Filters_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos`)
};

const en_admin_traces_filters_all = /** @type {(inputs: Admin_Traces_Filters_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

/**
* | output |
* | --- |
* | "All" |
*
* @param {Admin_Traces_Filters_AllInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_traces_filters_all = /** @type {((inputs?: Admin_Traces_Filters_AllInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Traces_Filters_AllInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_traces_filters_all(inputs)
	return en_admin_traces_filters_all(inputs)
});
export { admin_traces_filters_all as "admin.traces.filters.all" }